import React from 'react';
import { Minus, Plus } from 'lucide-react';
import { formatPrice } from '../../utils/priceFormatter';
import Tooltip from '../Tooltip';

const ToileAuMetreForm = ({
  metrage,
  setMetrage,
  largeurLaize,
  fabricCalculation
}) => {
  return (
    <div className="p-6 border-2 border-celadon rounded-lg">
      <h3 className="text-lg font-bold mb-4 flex items-center gap-2">
        Commande au mètre linéaire
        <Tooltip tooltipKey="commande-metre" size={16} />
      </h3>
      <p className="text-sm text-gray-600 mb-4">
        Largeur de laize : <strong>{largeurLaize} cm</strong>
      </p>
      <p className="text-sm text-gray-600 mb-4">
        Commande minimum : 1 mètre. Mètres entiers uniquement (ex: 1m, 2m, 3m...).
      </p>
      
      <div className="mb-4">
        <label className="block text-sm font-medium mb-2">Métrage (mètres linéaires)</label>
        <div className="flex items-center gap-3">
          <button
            onClick={() => setMetrage(Math.max(1, metrage - 1))}
            className="p-2 border border-gray-300 rounded hover:bg-gray-100 transition-colors"
          >
            <Minus size={16} />
          </button>
          <input
            type="number"
            value={metrage}
            onChange={(e) => setMetrage(Math.max(1, parseInt(e.target.value) || 1))}
            className="flex-1 px-4 py-2 border border-gray-300 rounded text-center font-medium focus:outline-none focus:border-celadon"
            min="1"
            step="1"
          />
          <button
            onClick={() => setMetrage(metrage + 1)}
            className="p-2 border border-gray-300 rounded hover:bg-gray-100 transition-colors"
          >
            <Plus size={16} />
          </button>
        </div>
      </div>

      {/* Affichage surface et prix si disponible */}
      {fabricCalculation && (
        <div className="mt-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
          <div className="space-y-2 text-sm">
            <div className="flex justify-between">
              <span className="text-gray-600">Surface totale :</span>
              <span className="font-medium">{((largeurLaize / 100) * metrage).toFixed(2)} m²</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Métrage :</span>
              <span className="font-medium">{metrage} m</span>
            </div>
            <div className="flex justify-between pt-2 border-t border-blue-300">
              <span className="text-sm font-semibold text-green-900">Prix total TTC:</span>
              <span className="text-2xl font-bold text-green-700">
                {formatPrice(fabricCalculation.price_total)} €
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ToileAuMetreForm;